/**
 * Created by slava on 19/2/20
 */

const ToolModel = function () {
    cleverapps.EventEmitter.call(this);

    this.root = new ToolMenuItem(cleverapps.Tool, null, "ROOT");

    this.path = this.root;
    this.search = "";

    ToolModel.AUTONAVIGATE = [
        {
            forces: true,
            path: ["Debug", "forces"]
        },
        {
            minimal: true,
            path: ["Debug", "minimal"]
        },
        {
            windows: [typeof ClansCupWindow !== "undefined" && ClansCupWindow].filter(Boolean),
            path: ["cups", "clan"]
        },
        {
            windows: [typeof ClansWindow !== "undefined" && ClansWindow,
                typeof MyClanWindow !== "undefined" && MyClanWindow].filter(Boolean),
            path: ["Debug", "clans"]
        },
        {
            windows: [typeof DailyTasksWindow !== "undefined" && DailyTasksWindow].filter(Boolean),
            path: ["dailyTasks"]
        },
        {
            windows: [typeof WeeklyGoalsWindow !== "undefined" && WeeklyGoalsWindow].filter(Boolean),
            path: ["weeklyGoals"]
        },
        {
            filter: function () {
                const mission = cleverapps.missionManager.getRunningMissions().find((mission) => {
                    const ViewClass = mission.getViewClass();
                    return typeof ViewClass === "function" && cleverapps.focusManager.currentWindow() instanceof ViewClass;
                });
                return mission && cleverapps.Tool.missions.listItems()[ToolMenuItem.ACTIVE_ITEM + mission.name];
            },
            path: function () {
                const mission = cleverapps.missionManager.getRunningMissions().find((mission) => {
                    const ViewClass = mission.getViewClass();
                    return typeof ViewClass === "function" && cleverapps.focusManager.currentWindow() instanceof ViewClass;
                });
                return ["missions", ToolMenuItem.ACTIVE_ITEM + mission.name];
            }
        },
        {
            filter: function () {
                return this.path === this.root && ComponentMap.get(cleverapps.Scenes.GetRunningScene(), GameSceneComponent);
            }.bind(this),

            path: ["game"]
        }
    ];
};

ToolModel.prototype = Object.create(cleverapps.EventEmitter.prototype);
ToolModel.prototype.constructor = ToolModel;

ToolModel.prototype.show = function (silent) {
    this.opened = true;
    this.autoNavigate();
    this.trigger("show", silent);

    cleverapps.debugStats.setEnabled(false);
};

ToolModel.prototype.hide = function (silent) {
    this.opened = false;
    this.trigger("hide", silent);

    cleverapps.debugStats.setEnabled(cleverapps.flags.toggleStatsMode ? false : cleverapps.flags.debugInfo !== false);
};

ToolModel.prototype.toggleSearch = function (search) {
    if (search !== this.search) {
        this._navigate(this.root, search);
    } else if (!search) {
        this.hide();
    }
};

ToolModel.prototype._navigate = function (path, search) {
    this.path = path;
    this.search = search || "";
    this.trigger("change", this.search);
};

ToolModel.prototype.reset = function () {
    this.path = this.root;
    this.search = "";
    this.purge();
};

ToolModel.prototype.isOpened = function () {
    return this.opened;
};

ToolModel.prototype.listMenuItems = function () {
    if (this.search) {
        return this.find(this.search);
    }
    const list = this.path.children();
    if (this.path.parent) {
        list.unshift(new ToolMenuItem(this.path.parent.entry, this.path.parent.parent, "back"));
    }
    return list;
};

ToolModel.prototype.autoNavigate = function () {
    for (let i = 0; i < ToolModel.AUTONAVIGATE.length; i++) {
        const option = ToolModel.AUTONAVIGATE[i];
        let selected = false;

        if (option.minimal && MinimalDialogue.current) {
            selected = true;
        } else if (option.forces && cleverapps.forces.isRunningForce()) {
            selected = true;
        } else if (option.windows && cleverapps.focusManager.listWindows().some((w) => [].concat(option.windows).some((ctor) => (typeof ctor === "string" ? w.focus === ctor : w instanceof ctor)))) {
            selected = true;
        } else if (option.filter && option.filter()) {
            selected = true;
        }

        if (selected) {
            let path = this.root;
            let optionPath = option.path;
            if (typeof optionPath === "function") {
                optionPath = optionPath();
            }

            optionPath.forEach((key) => {
                const activeChild = path.children().find((item) => item.key === key);

                path = activeChild;
            });

            this._navigate(path, "");
            break;
        }
    }
};

ToolModel.prototype.refresh = function () {
    this.trigger("change");
};

ToolModel.prototype.execute = function (path) {
    let item = this.root;

    path = path.split("/");
    path.forEach((key) => {
        item = item.children().find((item) => item.key === key);
    });

    item.clickHandler();
};

ToolModel.prototype.showPath = function (path) {
    this.show(true);
    this.backToRoot();
    this.execute(path);
    this.trigger("hideSpotlight");
};

ToolModel.prototype.backToRoot = function () {
    this.path = this.root;

    this.refresh();
};